import { useState } from 'react';

import OmeEntriesExportData from './OmeEntriesExportData';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const useOmeEntriesExportData = () => {
  const [omeEntriesExportState, setOmeEntriesExportState] = useState(INITIAL_STATE);

  const getOmeEntriesExport = (meetId, omeMeetEntryIds) => {
    OmeEntriesExportData.getOmeEntriesExportData(meetId, omeMeetEntryIds, omeEntriesExportState, setOmeEntriesExportState);
  }

  return {
    omeEntriesExportState,
    getOmeEntriesExport
  };
};

export default useOmeEntriesExportData;